import React from 'react';
import toast, { Toaster } from 'react-hot-toast';

import {confirmAlert} from "react-confirm-alert";
import Role from "../../inc/Role";
import {NavLink, useNavigate, useParams} from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import {Config} from '../../Config'
import moment from "moment-timezone";
import * as Utils from "../../inc/Utils";
import Select from 'react-select'
import DatePicker from "react-datepicker";
import {getKol} from "../../inc/Utils";
import {getOwnerRunningId} from "../../inc/Utils";
import {getOwnerRunningCode} from "../../inc/Utils";

export default function GenerateProjectCreate() {
    const roles = new Role();
    let userId = roles.loginUserId;
    let {encode} = useParams();

    let btnTextDefault = 'บันทึกข้อมูล';
    let btnTextLoading = 'กำลังบันทึก..';
    let [isLoading, setLoading] = React.useState(false);
    let [buttonText, setButtonText] = React.useState(btnTextDefault);
    const navigate = useNavigate();

    let [lang, setLanguage] = React.useState(null);
    let [langId, setLanguageId] = React.useState(null);
    let [projectType, setProjectType] = React.useState(null);
    let [projectTypeId, setProjectTypeId] = React.useState(null);
    let [project, setProject] = React.useState(null);
    let [projectId, setProjectId] = React.useState(null);
    let [campaignDate, setCampaignDate] = React.useState(null);
    let [campaign, setCampaign] = React.useState(null);
    let [campaignId, setCampaignId] = React.useState(null);
    let [agency, setAgency] = React.useState(null);
    let [agencyId, setAgencyId] = React.useState(null);
    let [platform, setPlatform] = React.useState(null);
    let [platformId, setPlatformId] = React.useState(null);

    let [projectPlaceholder, setProjectPlaceholder] = React.useState('...');
    let [campaignPlaceholder, setCampaignPlaceholder] = React.useState('...');

    let [disableProject, setDisableProject] = React.useState(true);
    let [disableCampaign, setDisableCampaign] = React.useState(true);
    let [disableTemplate, setDisableTemplate] = React.useState(true);

    let [campaignTemplate, setCampaignTemplate] = React.useState(null);
    let [campaignTemplateId, setCampaignTemplateId] = React.useState(null);

    let [generateTypeCampaign, setGenerateTypeCampaign] = React.useState(false);
    let [generateTypeAdsSet, setGenerateTypeAdsSet] = React.useState(false);
    let [generateTypeUTM, setGenerateTypeUTM] = React.useState(false);

    let refUrl = React.useRef();

    React.useEffect(() => {
        (async function() {
            try {
                setDisableTemplate(true);
                const resTemplate = await Utils.getCampaignTemplate(Utils.GENERATE_TYPE_PROJECT);
                setCampaignTemplate(resTemplate);
                setDisableTemplate(false);

                const resPlatform = await Utils.getPlatformAll();
                setPlatform(resPlatform);

                const resLanguage = await Utils.getLanguage();
                setLanguage(resLanguage);

                const resProjectType = await Utils.getProjectType();
                setProjectType(resProjectType);

                const resAgency = await Utils.getAgencySlug();
                let newAgencies = [];
                if(resAgency) {
                    let newA = resAgency.find(e => e.id === roles.agencyId).items;
                    let ownerIds = [];
                    for(let a of newA) {
                        ownerIds.push(a.ownerId);
                    }
                    for(let ag of resAgency) {
                        if(ag.items.find(e => ownerIds.includes(e.ownerId))) {
                            newAgencies.push({
                                id: ag.id,
                                slug: ag.slug,
                                name: ag.name
                            })
                        }
                    }
                }
                if(roles.permissionId !== Utils.SUPER_ADMIN_ID && roles.agencyId) {
                    newAgencies = newAgencies.filter(e => e.id === roles.agencyId);
                }
                setAgency(newAgencies);

                //-- Duplicate
                let resView = null;
                if(encode) {
                    let decode = Utils.decodeItem(encode);
                    let generateId = decode.id;
                    if(generateId) {
                        resView = await getView(generateId);
                        if(resTemplate) {
                            setCampaignTemplateId(resTemplate.filter(e => e.id === resView.campaignTemplateId)[0]);
                        }
                        if(resLanguage) {
                            setLanguageId(resLanguage.filter(e => e.id === resView.lang)[0]);
                        }
                        if(resProjectType) {
                            setProjectTypeId(resProjectType.filter(e => e.id === resView.projectTypeId)[0]);
                        }
                        if(resAgency) {
                            setAgencyId(resAgency.filter(e => e.id === resView.agencyId)[0]);
                        }
                        if(resPlatform) {
                            setPlatformId(resPlatform.filter(e => e.id === resView.adsPlatformId)[0]);
                        }
                        setCampaignDate(new Date(resView.campaignDate));
                        setGenerateTypeCampaign(resView.generateTypeCampaign);
                        setGenerateTypeAdsSet(resView.generateTypeAdsset);
                        setGenerateTypeUTM(resView.generateTypeUTM);

                        refUrl.current.value = resView.url;

                        if(resView.projectTypeId) {
                            await loadProject({
                                langId: resView.lang,
                                projectTypeId: resView.projectTypeId,
                                projectId: resView.projectId
                            });
                        }

                        if(resView.projectTypeId && resView.projectId) {
                            await loadCampaign({
                                langId: resView.lang,
                                projectTypeId: resView.projectTypeId,
                                projectId: resView.projectId,
                                campaignId: resView.campaignId
                            });
                        }
                    }
                }

                //-- Campaign
                await campaignDetail(resView);

                //-- AdsSet
                await adssetDetail(resView);

                //-- UTM
                await utmDetail(resView);

            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    async function getView(id) {
        const response = await fetch(Config.url.API_URL +'/api/generate/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                id: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onCreate = async () => {
        let campaignParam = null;
        let adssetParam = null;
        if(generateTypeCampaign) {
            campaignParam = await getCampaignParams();
        }
        if(generateTypeAdsSet) {
            adssetParam = await getAdssetParams();
        }

        let url = refUrl.current.value;

        if(!campaignTemplateId) {
            toast.error("กรุณาระบุ Campaign Template");
        }
        else if(!langId) {
            toast.error("กรุณาระบุ Language");
        }
        else if(!projectTypeId) {
            toast.error("กรุณาระบุ Project Type");
        }
        else if(!projectId) {
            toast.error("กรุณาระบุ Project");
        }
        else if(!campaignId) {
            toast.error("กรุณาระบุ Campaign ID");
        }
        else if(generateTypeCampaign && !agencyId) {
            toast.error("กรุณาระบุ Agency");
        }
        else if(!generateTypeCampaign && !generateTypeAdsSet && !generateTypeUTM) {
            toast.error("กรุณาระบุ Generate Type อย่างน้อย 1 ตัวเลือก");
        }
        else if(generateTypeCampaign && !campaignParam || (campaignParam && !campaignParam.success)) {
            toast.error("กรุณาเลือก Campaign Parameters ให้ครบถ้วน");
        }
        else if(generateTypeCampaign && campaignParam && campaignParam.params.length > 200) {
            toast.error("Campaign Parameters ขนาดตัวอักษรต้องไม่เกิน 200");
        }
        else if(generateTypeAdsSet && !adssetParam || (adssetParam && !adssetParam.success)) {
            toast.error("กรุณาเลือก Ads Set Parameters ให้ครบถ้วน");
        }
        else if(generateTypeAdsSet && adssetParam && adssetParam.params.length > 200) {
            toast.error("Ads Set Parameters ขนาดตัวอักษรต้องไม่เกิน 200");
        }
        else if(generateTypeAdsSet && !adsNamingSetNameTypeId) {
            toast.error("กรุณาระบุ Ads Set Type");
        }
        else if(generateTypeUTM && !url) {
            toast.error("กรุณาระบุ URL");
            refUrl.current.focus();
        }
        else if(generateTypeUTM && !utmTemplateId) {
            toast.error("กรุณาระบุ UTM Template");
        }
        else {

            let sourceTypeIds = [];
            if(generateTypeUTM) {
                setLoading(true);
                setButtonText('กำลังตรวจสอบ UTM...');

                let selectSourceTypeIds = document.getElementsByName('sourceTypeIds[]');
                let ownerSelectedId = 0;
                let ownerSelectedCode = 0;
                let ownerFullText = '';
                if(selectSourceTypeIds) {
                    for(let st of selectSourceTypeIds) {
                        if(st.value) {
                            let utmSourceTypeId = st.value;
                            let utmSourceId = 0;
                            let utmSourceTypeText = null;
                            let inputType = null;

                            if(utmSourceTypeId.includes(':CID')) {
                                let sp = utmSourceTypeId.split(':CID');
                                let contentId = sp[0];
                                utmSourceId = sp[1];
                                let contentView = await Utils.getContentIdView(contentId);
                                utmSourceTypeText = Utils.contentIdGenerater(contentView);
                                utmSourceTypeId = contentId;
                                inputType = Utils.API_TYPE_CONTENT_ID;
                            }
                            else if(utmSourceTypeId.includes(':OID')) {
                                let sp = utmSourceTypeId.split(':OID');
                                let ownerId = sp[0];
                                utmSourceId = sp[1];
                                let resOwner = await Utils.getOwnerView(ownerId);
                                let ownerCodeRow = await getOwnerRunningId(ownerId);
                                utmSourceTypeText = getOwnerRunningCode(resOwner.code, ownerCodeRow.code ?? 1);
                                utmSourceTypeId = ownerId;
                                inputType = Utils.API_TYPE_OWNER_ID;
                                ownerSelectedId = ownerId;
                                ownerSelectedCode = ownerCodeRow.code;
                                ownerFullText = utmSourceTypeText;
                            }
                            else if(utmSourceTypeId.includes(':CP')) {
                                let sp = utmSourceTypeId.split(':CP');
                                let campaignId = sp[0];
                                utmSourceId = sp[1];
                                utmSourceTypeText = campaignId;
                                utmSourceTypeId = 0;
                                inputType = Utils.API_TYPE_CAMPAIGN_ID;
                            }
                            else if(utmSourceTypeId.includes(':CN')) {
                                let sp = utmSourceTypeId.split(':CN');
                                let campaignName = sp[0];
                                utmSourceId = sp[1];
                                utmSourceTypeText = campaignName;
                                utmSourceTypeId = 0;
                                inputType = Utils.API_TYPE_CAMPAIGN_NAME;
                            }
                            else if(utmSourceTypeId.includes(':PJI')) {
                                let sp = utmSourceTypeId.split(':PJI');
                                let projectCode = sp[0];
                                utmSourceId = sp[1];
                                utmSourceTypeText = projectCode;
                                utmSourceTypeId = 0;
                                inputType = Utils.API_TYPE_PROJECT_ID;
                            }
                            else if(utmSourceTypeId.includes(':PJN')) {
                                let sp = utmSourceTypeId.split(':PJN');
                                let projectName = sp[0];
                                utmSourceId = sp[1];
                                utmSourceTypeText = projectName;
                                utmSourceTypeId = 0;
                                inputType = Utils.API_TYPE_PROJECT_NAME;
                            }
                            else if(utmSourceTypeId.includes(':PJS')) {
                                let sp = utmSourceTypeId.split(':PJS');
                                let projectSlug = sp[0];
                                utmSourceId = sp[1];
                                utmSourceTypeText = projectSlug;
                                utmSourceTypeId = 0;
                                inputType = Utils.API_TYPE_PROJECT_SLUG;
                            }
                            else if(utmSourceTypeId.includes(':PMS')) {
                                let sp = utmSourceTypeId.split(':PMS');
                                let promotionSlug = sp[0];
                                utmSourceId = sp[1];
                                utmSourceTypeText = promotionSlug;
                                utmSourceTypeId = 0;
                                inputType = Utils.API_TYPE_PROMOTION_SLUG;
                            }
                            else if(utmSourceTypeId.includes(':LINEOA')) {
                                let sp = utmSourceTypeId.split(':LINEOA');
                                let lineOAUrl = sp[0];
                                utmSourceId = sp[1];
                                utmSourceTypeText = lineOAUrl;
                                utmSourceTypeId = 0;
                                inputType = Utils.API_TYPE_LINE_OAID;
                            }
                            else {
                                let sourceTypeRow = await Utils.getUtmSourceTypeById(utmSourceTypeId);
                                utmSourceId = sourceTypeRow.utmSourceId;
                                utmSourceTypeText = sourceTypeRow.name;
                            }

                            sourceTypeIds.push({
                                utmSourceId: utmSourceId,
                                utmSourceTypeId: utmSourceTypeId,
                                utmSourceTypeText: utmSourceTypeText,
                                inputType: inputType
                            });
                        }
                    }
                }

                if(sourceTypeIds.length !== selectSourceTypeIds.length) {
                    setLoading(false);
                    setButtonText(btnTextDefault);
                    toast.error("กรุณาเลือก UTM ให้ครบถ้วน");
                    return;
                }
            }

            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: async() => {
                            setLoading(true);
                            setButtonText(btnTextLoading);

                            const body = {
                                campaignTemplateId: campaignTemplateId ? campaignTemplateId.id : null,
                                typeId: Utils.GENERATE_TYPE_PROJECT,
                                lang: langId ? langId.id : null,
                                projectTypeId: projectTypeId ? projectTypeId.id : null,
                                projectId: projectId ? projectId.project_code : null,
                                campaignDate: campaignDate ? new Date(campaignDate) : null,
                                campaignId: campaignId ? campaignId.campaign_id : null,
                                agencyId: agencyId ? agencyId.id : null,
                                adsPlatformId: platformId ? platformId.id:null,
                                url: url,
                                createdBy: userId,
                                createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                            };

                            if(generateTypeCampaign) {
                                body.generateTypeCampaign = 1;
                                body.paramsCampaign = campaignParam.params;
                                body.campaignSourceTypeIds = campaignParam.data;
                            }
                            if(generateTypeAdsSet) {
                                body.generateTypeAdsset = 1;
                                body.paramsAdsset = adssetParam.params;
                                body.adssetSourceTypeIds = adssetParam.data;
                                body.adsNamingSetNameTypeId = adsNamingSetNameTypeId ? adsNamingSetNameTypeId.id : null;
                            }
                            if(generateTypeUTM) {
                                //Main URL
                                url = url.toString().trim();

                                //Create Params
                                let params = await Utils.generateParams();
                                params = params + (hashtag ? '#' + hashtag.name:'');
                                let urlParam = url + '?' + params;

                                //Create Short URL (Rebrandly)
                                let rebrandlyUrl = null;
                                if(urlParam && rebrandlyChecked)  {
                                    const resShortUrl = await Utils.getRebrandlyShortURL(rebrandly, urlParam);
                                    rebrandlyUrl = resShortUrl.shortUrl;
                                    //rebrandlyUrl = 'rebrandlyUrl-XXX';
                                }

                                //Create Short URL (Short.IO)
                                let shortioUrl = null;
                                if(urlParam && shortioChecked)  {
                                    const resShortUrl = await Utils.createShortioShortURL(urlParam);
                                    shortioUrl = resShortUrl.path;
                                    //shortioUrl = 'shortioUrl-XXX';
                                }

                                body.generateTypeUTM = 1;
                                body.paramsUTM = params;
                                body.utmTemplateId = utmTemplateId ? utmTemplateId.id : null;
                                body.utmGroupId = null;
                                body.utmGroupItemId = null;
                                body.hashtag = hashtag ? hashtag.name : null;
                                body.shortUrl = rebrandlyUrl;
                                body.shortioUrl = shortioUrl;
                                body.utmSourceTypeIds = sourceTypeIds;
                            }

                            fetch(Config.url.API_URL +'/api/generate/create', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("บันทึกข้อมูลเรียบร้อย");
                                    setTimeout(function () {
                                        navigate('/generateProject', {replace: true});
                                    }, 1500);
                                }
                                else {
                                    setLoading(false);
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            });
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {
                            setLoading(false);
                            setButtonText(btnTextDefault);
                        }
                    }
                ]
            });
        }
    };

    const onChangeLanguageId = (obj) => {
        setLanguageId(obj);
        setProjectTypeId(null);
        setProject(null);
        setProjectId(null);
        setCampaign(null);
        setCampaignId(null);
        setCampaignItemSlugProject('');
        setAdssetItemSlugProject('');
    };

    const onChangeProjectTypeId = async (obj) => {
        setProjectTypeId(obj);
        setProjectPlaceholder('...');
        setProject(null);
        setProjectId(null);
        setCampaign(null);
        setCampaignId(null);

        if(obj && langId) {
            setCampaignItemSlugProject('');
            setAdssetItemSlugProject('');
            await loadProject({
                langId: langId.id,
                projectTypeId: obj.projectTypeId
            });
        }
    };

    const onChangeProjectId = async (obj) => {
        setProjectId(obj);
        setCampaignPlaceholder('...');
        setCampaign(null);
        setCampaignId(null);
        refUrl.current.value = obj && obj.project_url? obj.project_url : '';

        if(generateTypeUTM) {
            setShowUtmListing(false);
            setUtmTemplateId(null);
        }

        if(obj) {
            setCampaignItemSlugProject(langId.id + '-' + obj.project_type_slug + '-' + obj.project_slug);
            setAdssetItemSlugProject(langId.id + '-' + obj.project_type_slug + '-' + obj.project_slug);
            await loadCampaign({
                langId: langId.id,
                projectTypeId: projectTypeId.id,
                projectId: obj.projectId
            });
        }
    };

    const onChangeCampaignDate = async (value) => {
        setCampaignDate(value);
        setCampaign(null);
        setCampaignId(null);

        await loadCampaign({
            langId: langId ? langId.id : null,
            projectTypeId: projectTypeId ? projectTypeId.id : null,
            projectId: projectId ? projectId.project_code : null,
            campaignDate: value ? new Date(value):null
        });
    };

    const onChangeCampaignId = (obj) => {
        setCampaignId(obj);
        if(generateTypeUTM) {
            setShowUtmListing(false);
            setUtmTemplateId(null);
        }
    };

    const onChangeAgencyId = (obj) => {
        setAgencyId(obj);
    };

    const onChangePlatformId = async (platformRow) => {
        setPlatformId(platformRow);
    };

    //-- Template
    const onChangeCampaignTemplateId =  async (obj) => {
        setCampaignTemplateId(null);
        setLanguageId(null);
        setProjectTypeId(null);
        setProjectId(null);
        setCampaignId(null);
        setAgencyId(null);
        setPlatformId(null);
        setGenerateTypeCampaign(false);
        setGenerateTypeAdsSet(false);
        setGenerateTypeUTM(false);
        refUrl.current.value = '';
        setAgencyId(agency.filter(e => e.id === roles.agencyId)[0]);

        //Set data from template
        if(obj && obj.id) {
            setCampaignTemplateId(obj);
            let templateRow = campaignTemplate.filter(e => e.id === obj.id)[0];
            setLanguageId(lang.filter(e => e.id === templateRow.lang)[0]);
            setProjectTypeId(projectType.filter(e => e.id === templateRow.projectTypeId)[0]);
            setCampaignDate(templateRow.campaignDate ? new Date(templateRow.campaignDate):'');
            setPlatformId(platform.filter(e => e.id === templateRow.adsPlatformId)[0]);
            refUrl.current.value = templateRow.url ?? '';

            await loadProject({
                langId: templateRow.lang,
                projectTypeId: templateRow.projectTypeId,
                projectId: templateRow.projectId
            });
            await loadCampaign({
                langId: templateRow.lang,
                projectTypeId: templateRow.projectTypeId,
                projectId: templateRow.projectId,
                campaignId: templateRow.campaignId
            });
        }
    };

    const loadProject = async (param) => {
        setDisableProject(true);
        setDisableCampaign(true);
        setProjectPlaceholder('กำลังโหลด...');
        const proj = await Utils.getProjectCode(param.langId, param.projectTypeId);
        if(proj && proj.data) {
            setProject(proj.data);
            setProjectPlaceholder('Select...');
            setDisableProject(false);
            if(param.projectId) {
                let prj = proj.data.filter(e => e.project_code === param.projectId)[0];
                setProjectId(prj);
                setCampaignItemSlugProject(param.langId + '-' + prj.project_type_slug + '-' + prj.project_slug);
                setAdssetItemSlugProject(param.langId + '-' + prj.project_type_slug + '-' + prj.project_slug);
            }
        }
        else {
            setProject(null);
            setProjectPlaceholder('ไม่พบข้อมูล..');
            setDisableProject(true);
        }
    };

    const loadCampaign = async (param) => {
        setCampaignPlaceholder('กำลังโหลด...');
        const camp = await Utils.getCampaign({
            langId: param.langId,
            projectType: param.projectTypeId,
            projectCode: param.projectId,
            campaignDate: campaignDate
        });
        let campaignList = [];
        campaignList.push({
            campaign_id: '0638A01',
            campaign_name: 'NonDefine'
        });
        if(typeof camp !== 'undefined' && camp.data) {
            if(camp.data[0].promotions) {
                for(let rs of camp.data[0].promotions) {
                    campaignList.push({
                        campaign_id: rs.campaign_id,
                        campaign_name: rs.campaign_name
                    });
                }
            }
            setDisableCampaign(false);
            if(param.campaignId) {
                setCampaignId(campaignList.filter(e => e.campaign_id === param.campaignId)[0]);
            }
        }
        else {
            setCampaignId(campaignList[0]);
        }
        setCampaign(campaignList);
        setCampaignPlaceholder('Select...');
        setDisableCampaign(false);
    };

    //region -- Campaign
    let [campaignItemSelected, setCampaignItemSelected] = React.useState(null);
    let [campaignAdsNaming, setCampaignAdsNaming] = React.useState(null);
    let [campaignExample, setCampaignExample] = React.useState('');
    let [campaignKolPage, setCampaignKolPage] = React.useState('');
    let [campaignPreview, setCampaignPreview] = React.useState('');
    let [campaignItemSlugProject, setCampaignItemSlugProject] = React.useState('');
    let [campaignItemFreeForm, setCampaignItemFreeForm] = React.useState('');

    const campaignDetail = async (view) => {
        if(view && view.generateTypeCampaign) {
            setGenerateTypeCampaign(true);
            let items = view.campaignItems;
            let sourceTypeSelectedIds = [];
            if (items) {
                for (let rs of items) {
                    let adsNamingSourceId = rs.adsNamingSourceId;
                    if (adsNamingSourceId) {
                        if (rs.inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                            sourceTypeSelectedIds.push(adsNamingSourceId + ':KOL' + rs.adsNamingId);
                        } else {
                            sourceTypeSelectedIds.push(adsNamingSourceId);
                        }
                    }
                }
            }
            setCampaignItemSelected(sourceTypeSelectedIds);
        }

        const resAdsNaming = await Utils.getAdsNamingCampaign();
        if(resAdsNaming.length > 0) {
            let ex = [];
            for(let rs of resAdsNaming) {
                if(rs.inputType !== Utils.ADSNAMING_TYPE_SLUG_PROMOTION && rs.inputType !== Utils.ADSNAMING_TYPE_SLUG_SPECIAL) {
                    ex.push('{' + rs.name + '}');
                    if(rs.name === 'Objective') {
                        ex.push('{Platform}');
                    }
                }
            }
            setCampaignExample('{Agency}|{Project ID}|' + ex.join('_') + '_[ST]|{Campaign ID}');

            let newKolPageId = [];
            let items = view ? view.campaignItems:null;
            for(let rs of resAdsNaming) {
                if(rs.inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                    const resKolPage = await getKol();
                    if(resKolPage) {
                        let campaignKolPageIds = [];
                        for(let row of resKolPage) {
                            let id = row.id;
                            campaignKolPageIds.push({
                                id: id + ':KOL' + rs.id,
                                name:  row.name
                            });
                        }
                        rs.source = campaignKolPageIds;

                        newKolPageId.push({
                            id: rs.id,
                            data: campaignKolPageIds
                        });
                    }
                }
                if(rs.inputType === Utils.ADSNAMING_TYPE_FREEFORM && items && items.length > 0) {
                    setCampaignItemFreeForm(items.filter(e => e.inputType === Utils.ADSNAMING_TYPE_FREEFORM)[0].text);
                }
            }
            setCampaignKolPage(newKolPageId);
        }
        setCampaignAdsNaming(resAdsNaming);
    };
    const onCampaignPreview = async () => {
        const param = await getCampaignParams();
        setCampaignPreview(param.params);
    };
    async function getCampaignParams() {
        let textParams = [];
        let sourceIds = [];
        let kolIds = [];

        //STEP 1 : Find Selected
        let sourceTypeIds = [];
        let sourceTypeAllIds = [];
        let selectSourceTypeIds = document.getElementsByName('sourceTypeIdsCampaign[]');
        if(selectSourceTypeIds) {
            for(let st of selectSourceTypeIds) {
                let sourceTypeId = st.value;
                if(sourceTypeId) {
                    //STEP 1.1 : Find special selector
                    if(sourceTypeId.includes(':KOL')) {
                        let sp = sourceTypeId.split(':KOL');
                        let kolId = sp[0];
                        let adsNamingId = sp[1];
                        if(kolId) {
                            campaignKolPage.find(rs => {
                                if(parseInt(rs.id) === parseInt(adsNamingId)) {
                                    let data = rs.data.find(e => {
                                        let id = e.id;
                                        if(id.toString().includes(kolId + ':')) {
                                            return e;
                                        }
                                    });
                                    if(data) {
                                        kolIds.push({
                                            adsNamingSourceId: parseInt(kolId),
                                            adsNamingId: parseInt(adsNamingId),
                                            name: data ? data.name : null,
                                            inputType: Utils.ADSNAMING_TYPE_KOL_PAGE
                                        });
                                    }
                                }
                            });
                        }
                    }
                    else {
                        sourceTypeIds.push(sourceTypeId);
                    }
                    sourceTypeAllIds.push(sourceTypeId);
                }
            }
        }

        //STEP 2 : Get selector type
        if(sourceTypeIds.length > 0) {
            let result = await Utils.getSourceTypeForParam(sourceTypeIds);
            if(result) {
                for(let row of result) {
                    sourceIds.push({
                        adsNamingSourceId: row.id,
                        adsNamingId: row.adsNamingId,
                        name: row.name,
                        inputType: null
                    });
                }
            }
        }

        //STEP 4 : Get for params
        if(campaignAdsNaming.length > 0) {
            campaignAdsNaming.map(async (row, index) => {
                let value = '';
                let inputText = "sourceTypeTextCampaign[" + row.id + "]";
                let textSourceTypeIds = document.getElementsByName(inputText);

                if(textSourceTypeIds && textSourceTypeIds[0]) {
                    value = textSourceTypeIds[0].value;
                    if(value.length > 0) {
                        textParams.push({
                            adsNamingSourceId: null,
                            adsNamingId: row.id,
                            text: value,
                            inputType: row.inputType
                        });
                    }
                }
                else {
                    if(row.inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                        if(kolIds) {
                            let find = kolIds.find(kol => {
                                if(kol.adsNamingId === row.id) {
                                    return kol;
                                }
                            });
                            if(find && find.name) {
                                textParams.push({
                                    adsNamingSourceId: find.adsNamingSourceId,
                                    adsNamingId: row.id,
                                    text: find.name,
                                    inputType: row.inputType
                                });
                            }
                        }
                    }
                    else {
                        let find = sourceIds.find(rs => {
                            if(parseInt(rs.adsNamingId) === parseInt(row.id)) {
                                return rs;
                            }
                        });
                        if(find && find.name) {
                            textParams.push({
                                adsNamingSourceId: find.adsNamingSourceId,
                                adsNamingId: row.id,
                                text: find.name,
                                inputType: null
                            });

                            if(row.name === 'Objective') {
                                let platformName = '';
                                if(platform && platformId && platformId.id) {
                                    platformName = platform.filter(e => e.id === platformId.id)[0].name;
                                    textParams.push({
                                        adsNamingSourceId: null,
                                        adsNamingId: null,
                                        text: platformName,
                                        inputType: null
                                    });
                                }
                            }
                        }
                    }
                }
            });
        }

        let agencySlug = '';
        if(agencyId && agencyId.id) {
            const resAgency = await Utils.getAgencyView(agencyId.id);
            agencySlug = resAgency.slug;
        }

        let params = agencySlug + '|' + (projectId ? projectId.project_code:'') + '|' + textParams.map(x => x.text).join('_') + '_[ST]|' + (campaignId ? campaignId.campaign_id:'');

        return {
            params: params,
            data: textParams,
            success: sourceTypeAllIds.length === selectSourceTypeIds.length
        };
    }
    //endregion

    //region -- Ads Set
    let [adsNamingSetNameType, setAdsNamingSetNameType] = React.useState(null);
    let [adsNamingSetNameTypeId, setAdsNamingSetNameTypeId] = React.useState(null);
    let [adssetItemSelected, setAdssetItemSelected] = React.useState(null);
    let [adssetAdsNaming, setAdssetAdsNaming] = React.useState(null);
    let [adssetExample, setAdssetExample] = React.useState('');
    let [adssetPreview, setAdssetPreview] = React.useState('');
    let [adssetItemSlugProject, setAdssetItemSlugProject] = React.useState('');
    let [adssetItemFreeForm, setAdssetItemFreeForm] = React.useState('');

    const adssetDetail = async (view) => {
        if(view && view.generateTypeAdsset) {
            setGenerateTypeAdsSet(true);
            let items = view.adssetItems;
            let sourceTypeSelectedIds = [];
            if (items) {
                for (let rs of items) {
                    let adsNamingSourceId = rs.adsNamingSourceId;
                    if (adsNamingSourceId) {
                        sourceTypeSelectedIds.push(adsNamingSourceId);
                    }

                    if(rs.inputType === Utils.ADSNAMING_TYPE_FREEFORM && items && items.length > 0) {
                        setAdssetItemFreeForm(items.filter(e => e.inputType === Utils.ADSNAMING_TYPE_FREEFORM)[0].text);
                    }
                }
            }
            setAdssetItemSelected(sourceTypeSelectedIds);
        }

        const resSetNameType = await Utils.getAdsNamingSetNameType();
        setAdsNamingSetNameType(resSetNameType);

        if(view && view.adsNamingSetNameTypeId && resSetNameType) {
            setAdsNamingSetNameTypeId(resSetNameType.filter(e => e.id === view.adsNamingSetNameTypeId)[0]);
        }

        const resAdssetName = await Utils.getAdsNamingSetName();
        if(resAdssetName.length > 0) {
            let ex = [];
            let ex2 = [];
            let newAdsNaming = [];
            if(resAdssetName) {
                newAdsNaming = resAdssetName.filter(row => row.inputType !== Utils.ADSNAMING_TYPE_SLUG_PROMOTION && row.inputType !== Utils.ADSNAMING_TYPE_SLUG_SPECIAL);
                let xLen = newAdsNaming.length;
                if(xLen > 1) {
                    for(let i=0;i<2;i++) {
                        ex.push('{' + newAdsNaming[i].name + '}');
                    }
                }
                if(xLen > 2) {
                    for(let j=2;j<xLen;j++) {
                        ex2.push('{' + newAdsNaming[j].name + '}');
                    }
                }
            }
            setAdssetAdsNaming(newAdsNaming);
            setAdssetExample(ex.join('_') + '|' + ex2.join('_') + '_{Platform}|{Type}_[ST]');
        }
    };
    const onAdssetPreview = async () => {
        const param = await getAdssetParams();
        setAdssetPreview(param.params);
    };
    async function getAdssetParams() {
        let textParams = [];
        let textBoxParams = [];
        let sourceIds = [];

        //STEP 1 : Find Selected
        let sourceTypeIds = [];
        let sourceTypeAllIds = [];
        let selectSourceTypeIds = document.getElementsByName('sourceTypeIdsAdsset[]');
        if(selectSourceTypeIds) {
            for(let st of selectSourceTypeIds) {
                let sourceTypeId = st.value;
                if(sourceTypeId) {
                    //STEP 1.1 : Find special selector
                    sourceTypeIds.push(sourceTypeId);
                    sourceTypeAllIds.push(sourceTypeId);
                }
            }
        }

        //STEP 2 : Get selector type
        if(sourceTypeIds.length > 0) {
            let result = await Utils.getSourceTypeForParam(sourceTypeIds);
            if(result) {
                for(let row of result) {
                    sourceIds.push({
                        adsNamingSourceId: row.id,
                        adsNamingId: row.adsNamingId,
                        name: row.name,
                        inputType: null
                    });
                }
            }
        }

        //STEP 4 : Get for params
        if(adssetAdsNaming.length > 0) {
            adssetAdsNaming.map(async (row, index) => {
                let value = '';
                let inputText = "sourceTypeTextAdsset[" + row.id + "]";
                let textSourceTypeIds = document.getElementsByName(inputText);

                if(textSourceTypeIds && textSourceTypeIds[0]) {
                    value = textSourceTypeIds[0].value;
                    textParams.push({
                        adsNamingSourceId: null,
                        adsNamingId: row.id,
                        text: value,
                        inputType: row.inputType
                    });
                    textBoxParams = textParams;
                }
                else {
                    let find = sourceIds.find(rs => {
                        if(parseInt(rs.adsNamingId) === parseInt(row.id)) {
                            return rs;
                        }
                    });
                    if(find && find.name) {
                        textParams.push({
                            adsNamingSourceId: find.adsNamingSourceId,
                            adsNamingId: row.id,
                            text: find.name,
                            inputType: null
                        });
                    }
                }
            });
        }

        //Fixed BG
        let bg = textParams.length > 0 ? textParams[0].text:'';

        //Fixed Slug Project
        let slugProject = textBoxParams.length > 1 ? textParams[1].text:'';

        //After that
        let textParamsNew = [];
        let showOtherParam = '';
        let xLength = textBoxParams.length;

        if(textBoxParams.length > 2) {
            for(let i=2;i<xLength;i++) {
                if(textBoxParams[i].text.length > 0) {
                    textParamsNew.push({
                        adsNamingSourceId: textBoxParams[i].adsNamingSourceId,
                        adsNamingId: textBoxParams[i].id,
                        text: textBoxParams[i].text,
                        inputType: null
                    });
                }
            }
            showOtherParam = textParamsNew.map(x => x.text).join('_');
        }

        let platformName = '';
        if(platform && platformId && platformId.id) {
            platformName = '_' + platform.filter(e => e.id === platformId.id)[0].name;
        }

        let params = bg + '_' + slugProject + '|' + showOtherParam + platformName + '|' + (adsNamingSetNameTypeId ? adsNamingSetNameTypeId.name:'') + '_[ST]';

        return {
            params: params,
            data: textParams,
            success: sourceTypeAllIds.length === selectSourceTypeIds.length
        };
    }
    const onChangeAdsNamingSetNameTypeId = (obj) => {
        setAdsNamingSetNameTypeId(obj);
    };
    //endregion

    //region -- UTM
    let [utmTemplate, setUtmTemplate] = React.useState(null);
    let [utmTemplateId, setUtmTemplateId] = React.useState(null);
    let [hashtagList, setHashtagList] = React.useState(null);
    let [hashtag, setHashtag] = React.useState(null);
    let [rebrandly, setRebrandly] = React.useState(null);
    let [shortio, setShortIO] = React.useState(null);
    let [rebrandlyChecked, setRebrandlyChecked] = React.useState(false);
    let [shortioChecked, setShortioChecked] = React.useState(false);
    let [utmPreviewing, setUTMPreviewing] = React.useState(false);
    let [utmPreview, setUTMPreview] = React.useState('');
    let [utm, setUtm] = React.useState('');
    let [showUTMListing, setShowUtmListing] = React.useState(false);
    let [templateSource, setTemplateSource] = React.useState('');
    let [contentId, setContentId] = React.useState('');
    let [ownerId, setOwnerId] = React.useState('');
    let [userAgency, setUserAgency] = React.useState(null);
    let [utmItemSelected, setUtmItemSelected] = React.useState([]);

    const utmDetail = async (view) => {
        if(view && view.generateTypeUTM) {
            const resTemplate = await Utils.getTemplate({agencyId: roles.agencyId});
            setUtmTemplate(resTemplate);
            const resRebrandly = await Utils.getRebrandly();
            setRebrandly(resRebrandly);
            const resShortIO = await Utils.getShortIO();
            setShortIO(resShortIO);
            const resHashtag = await Utils.getHashtag();
            setHashtagList(resHashtag);
            const resAgency = await Utils.getAgency({agencyId: roles.agencyId});
            if(resAgency) {
                setUserAgency(resAgency[0]);
            }

            setUtmTemplateId(resTemplate.filter(e => e.id === view.utmTemplateId)[0]);
            setHashtag(resHashtag.filter(e => e.name === view.hashtag)[0]);
            await groupItemChange(view.utmTemplateId, view);
        }
    };
    const onUTMPreview = async () => {
        setUTMPreviewing(true);
        let params = await Utils.generateParams({
            langId: langId
        });

        let url = refUrl ? refUrl.current.value : '';
        let previewUrl = (url ? url.toString().trim() + '?':'') + params + (hashtag ? '#' + hashtag.name:'');

        setUTMPreviewing(false);
        setUTMPreview(previewUrl);
    };
    const onChangeTemplateId = async (obj) => {
        setShowUtmListing(false);
        setUtmTemplateId(obj);
        setUTMPreview('');

        if(obj && obj.id) {
            const resSource = await Utils.getTemplateSourceById(obj.id);
            setTemplateSource(resSource);
            const resUtm = await Utils.getUtmByIds(resSource);
            setUtm(resUtm);
            setShowUtmListing(true);

            if(resSource.length > 0) {
                //example
                for(let utm of resUtm) {
                    if(resSource) {
                        let ex = [];
                        for(let rs of resSource) {
                            if(utm.id === rs.utmId) {
                                ex.push('{' + rs.source.name + '}');
                            }
                        }
                        utm.example = ex.join('_');
                    }
                }

                resSource.map( async (rs, idx) => {
                    if(rs.source.inputType === Utils.API_TYPE_CONTENT_ID) {
                        const resContentId = await Utils.getContentId({agencyId: roles.agencyId});
                        let newContentId = [];
                        if(resContentId) {
                            for(let row of resContentId) {
                                newContentId.push({
                                    id: row.id,
                                    xid: row.id + ':CID' + rs.source.id,
                                    name:  Utils.contentIdGenerater(row)
                                });
                            }
                        }
                        setContentId(newContentId);
                    }
                    else if(rs.source.inputType === Utils.API_TYPE_OWNER_ID) {
                        const resOwnerId = await Utils.getOwner({agencyId: roles.agencyId});
                        let newOwnerId = [];
                        if(resOwnerId) {
                            for(let row of resOwnerId) {
                                newOwnerId.push({
                                    id: row.id,
                                    xid: row.id + ':OID' + rs.source.id,
                                    name: row.code.charAt(0) + ' : ' + row.name
                                });
                            }
                        }
                        setOwnerId(newOwnerId);
                    }
                });
            }
        }
    };
    const onChangeHashtag = (obj) => {
        setHashtag(obj);
    };
    const loadUTMMaster = async (isChecked) => {
        if(isChecked) {
            const resTemplate = await Utils.getTemplate({agencyId: roles.agencyId});
            setUtmTemplate(resTemplate);
            const resRebrandly = await Utils.getRebrandly();
            setRebrandly(resRebrandly);
            const resShortIO = await Utils.getShortIO();
            setShortIO(resShortIO);
            const resHashtag = await Utils.getHashtag();
            setHashtagList(resHashtag);
            const resAgency = await Utils.getAgency({agencyId: roles.agencyId});
            if(resAgency) {
                setUserAgency(resAgency[0]);
            }
        }
    };
    const groupItemChange = async (utmTemplateId, resView) => {

        //set selected
        const resSource = await Utils.getTemplateSourceById(utmTemplateId);
        const resUtm = await Utils.getUtmByIds(resSource);
        if(resView) {
            let sourceTypeSelectedIds = [];
            for(let rs of resView.utmItems) {
                let utmSourceTypeId = rs.utmSourceTypeId;
                if(rs.inputType === Utils.API_TYPE_CONTENT_ID) {
                    const resContentId = await Utils.getContentId({agencyId: roles.agencyId});
                    let newContentId = [];
                    if(resContentId) {
                        for(let row of resContentId) {
                            newContentId.push({
                                id: row.id,
                                xid: row.id + ':CID' + rs.utmSourceId,
                                name:  Utils.contentIdGenerater(row)
                            });
                        }
                    }
                    setContentId(newContentId);
                    sourceTypeSelectedIds.push(utmSourceTypeId + ':CID' + rs.utmSourceId);
                }
                else if(rs.inputType === Utils.API_TYPE_OWNER_ID) {
                    const resOwnerId = await Utils.getOwner({agencyId: roles.agencyId});
                    let newOwnerId = [];
                    if(resOwnerId) {
                        for(let row of resOwnerId) {
                            newOwnerId.push({
                                id: row.id,
                                xid: row.id + ':OID' + rs.utmSourceId,
                                name: row.code.charAt(0) + ' : ' + row.name
                            });
                        }
                    }
                    setOwnerId(newOwnerId);
                    sourceTypeSelectedIds.push(utmSourceTypeId + ':OID' + rs.utmSourceId);
                }
                else if(rs.inputType === Utils.API_TYPE_LINE_OAID) {
                    sourceTypeSelectedIds.push(rs.utmSourceTypeText + ':LINEOA' + rs.utmSourceId);
                }
                else if(rs.inputType !== Utils.API_TYPE_CAMPAIGN_ID
                    && rs.inputType !== Utils.API_TYPE_CAMPAIGN_NAME
                    && rs.inputType !== Utils.API_TYPE_PROJECT_ID
                    && rs.inputType !== Utils.API_TYPE_PROJECT_NAME
                    && rs.inputType !== Utils.API_TYPE_PROJECT_SLUG
                    && rs.inputType !== Utils.API_TYPE_PROMOTION_SLUG
                ) {
                    sourceTypeSelectedIds.push(utmSourceTypeId);
                }
            }
            setUtmItemSelected(sourceTypeSelectedIds);
        }

        //setup default data
        if(resUtm) {
            //example
            for(let utm of resUtm) {
                if(resSource) {
                    let ex = [];
                    for(let rs of resSource) {
                        if(utm.id === rs.utmId) {
                            ex.push('{' + rs.source.name + '}');
                        }
                    }
                    utm.example = ex.join('_');
                }
            }

            if(resSource.length > 0) {

                let chkCID = resSource.find(e => e.source.inputType === Utils.API_TYPE_CONTENT_ID);
                let resContentId = null;
                if(chkCID) {
                    resContentId = await Utils.getContentId({agencyId: roles.agencyId});
                }

                let chkOID = resSource.find(e => e.source.inputType === Utils.API_TYPE_OWNER_ID);
                let resOnwerId = null;
                if(chkOID) {
                    resOnwerId = await Utils.getOwner({agencyId: roles.agencyId});
                }

                resSource.map( async (rs, index2) => {
                    if(rs.source.inputType === Utils.API_TYPE_CONTENT_ID) {
                        let newContentId = [];
                        if(resContentId) {
                            for(let row of resContentId) {
                                let id = row.id;
                                newContentId.push({
                                    yid: id,
                                    xid: row.id + ':CID' + rs.source.id,
                                    name: Utils.contentIdGenerater(row)
                                });
                            }
                            rs.source.sourceType = newContentId;
                        }
                    }
                    else if(rs.source.inputType === Utils.API_TYPE_OWNER_ID) {
                        let newOwnerId = [];
                        if(resOnwerId) {
                            for(let row of resOnwerId) {
                                let id = row.id;
                                newOwnerId.push({
                                    yid: id,
                                    xid: row.id + ':OID' + rs.source.id,
                                    name: row.code.charAt(0) + ' : ' + row.name
                                });
                            }
                            rs.source.sourceType = newOwnerId;
                        }
                    }
                })
            }
        }
        setUtm(resUtm);
        setTemplateSource(resSource);
        //end example

        setShowUtmListing(true);
    };
    //endregion

    return (

        <main>
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Generate Project</div>
                    <span className="ms-1">/</span> <span className="text-muted">Create</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <div className="col-12 col-md-5">
                        <form className="row g-3">
                            <div className="col-12">
                                <label htmlFor="langId" className="form-label">Campaign Template <span className="text-danger">*</span></label>
                                <Select
                                    isClearable={true}
                                    isDisabled={disableTemplate}
                                    classNamePrefix="form-select-search"
                                    options={campaignTemplate}
                                    onChange={(event) => onChangeCampaignTemplateId(event)}
                                    value={campaignTemplateId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>
                            <div className="col-12">
                                <label htmlFor="url" className="form-label">URL <span className="text-danger">*</span></label>
                                <textarea className="form-control" id="url" ref={refUrl} rows={5} disabled={campaignTemplateId}></textarea>
                            </div>
                            <div className="col-12">
                                <label htmlFor="langId" className="form-label">Language <span className="text-danger">*</span></label>
                                <Select
                                    isDisabled={campaignTemplateId}
                                    classNamePrefix="form-select-search"
                                    options={lang}
                                    onChange={(event) => onChangeLanguageId(event)}
                                    value={langId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>
                            <div className="col-12">
                                <label htmlFor="projectTypeId" className="form-label">Project Type <span className="text-danger">*</span></label>
                                <Select
                                    isDisabled={campaignTemplateId}
                                    classNamePrefix="form-select-search"
                                    options={projectType}
                                    onChange={(event) => onChangeProjectTypeId(event)}
                                    value={projectTypeId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>
                            <div className={projectTypeId ? 'col-12':'d-none'}>
                                <label htmlFor="projectId" className="form-label">Project <span className="text-danger">*</span></label>
                                <Select
                                    isDisabled={disableProject || campaignTemplateId}
                                    classNamePrefix="form-select-search"
                                    placeholder={projectPlaceholder}
                                    options={project}
                                    onChange={(event) => onChangeProjectId(event)}
                                    value={projectId}
                                    getOptionValue={(option) => `${option.project_code}`}
                                    getOptionLabel={(option) => `${option.project_code} : ${option.project_title}`}
                                />
                            </div>
                            <div className={projectTypeId ? 'col-12':'d-none'}>
                                <label htmlFor="campaignDate" className="form-label">Campaign Date <span className="text-danger d-none">*</span></label>
                                <DatePicker
                                    selected={campaignDate}
                                    disabled={campaignTemplateId}
                                    onChange={(date) => onChangeCampaignDate(date)}
                                    dateFormat="yyyy-MM-dd"
                                    wrapperClassName="w-100"
                                    className="form-control w-100" />
                            </div>
                            <div className={projectTypeId ? 'col-12':'d-none'}>
                                <label htmlFor="campaignId" className="form-label">Campaign ID <span className="text-danger">*</span></label>
                                <Select
                                    isDisabled={disableCampaign || campaignTemplateId}
                                    classNamePrefix="form-select-search"
                                    placeholder={campaignPlaceholder}
                                    options={campaign}
                                    onChange={(event) => onChangeCampaignId(event)}
                                    value={campaignId}
                                    getOptionValue={(option) => `${option.campaign_id}`}
                                    getOptionLabel={(option) => `${option.campaign_id} : ${option.campaign_name}`}
                                />
                            </div>
                            <div className="col-12 mt-4">
                                <button type="button" className="btn btn-primary" onClick={onCreate} disabled={isLoading}><span
                                    className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {buttonText}</button>
                                <NavLink className="btn btn-sm btn-light ms-2" to='/generateProject'><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                                <Toaster position="bottom-right" />
                            </div>
                        </form>
                    </div>
                    <div className="col-12 col-md-7 mt-3 mt-md-0">
                        <form className="row g-3">
                            <div className="col-12">
                                <label htmlFor="langId" className="form-label">Generate Type <span className="text-danger">*</span></label>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-check">
                                            <input className="form-check-input" id="checkCampaign" name="checkCampaign" type="checkbox" onChange={e => {
                                                setGenerateTypeCampaign(e.target.checked);
                                            }} checked={generateTypeCampaign} />
                                            <label className="form-check-label campaign-color fw-bold" htmlFor="checkCampaign">
                                                Campaign
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-check">
                                            <input className="form-check-input" id="checkAdsSet" name="checkAdsSet" type="checkbox" onChange={e => {
                                                setGenerateTypeAdsSet(e.target.checked);
                                            }} checked={generateTypeAdsSet} />
                                            <label className="form-check-label adsset-color fw-bold" htmlFor="checkAdsSet">
                                                Ads Set
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-check">
                                            <input className="form-check-input" id="checkUTM" name="checkUTM" type="checkbox" onChange={async e => {
                                                setGenerateTypeUTM(e.target.checked);
                                                await loadUTMMaster(e.target.checked);
                                            }} checked={generateTypeUTM} />
                                            <label className="form-check-label utm-color fw-bold" htmlFor="checkUTM">
                                                UTM
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={"col-12 mt-3" + (generateTypeCampaign || generateTypeAdsSet ? '':' d-none')}>
                                <label htmlFor="platformId" className="form-label">Platform</label>
                                <Select
                                    classNamePrefix="form-select-search"
                                    options={platform}
                                    onChange={(event) => onChangePlatformId(event)}
                                    value={platformId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>
                        </form>

                        {
                            generateTypeCampaign || generateTypeAdsSet || generateTypeUTM ?
                                <>
                                    <ul className="nav nav-tabs mt-3" id="myTab" role="tablist">
                                        {
                                            generateTypeCampaign ?
                                                <li className="nav-item ms-1" role="presentation">
                                                    <button className={"nav-link campaign-color active"} id="tabCampaign-tab" data-bs-toggle="tab"
                                                            data-bs-target="#tabCampaign" type="button" role="tab" aria-controls="tabCampaign"
                                                            aria-selected="true">Campaign
                                                    </button>
                                                </li> : ''
                                        }
                                        {
                                            generateTypeAdsSet ?
                                                <li className="nav-item ms-1" role="presentation">
                                                    <button className={"nav-link adsset-color" + (!generateTypeCampaign ? ' active':'')} id="tabAdsSet-tab" data-bs-toggle="tab"
                                                            data-bs-target="#tabAdsSet" type="button" role="tab" aria-controls="profile"
                                                            aria-selected="false">Ads Set
                                                    </button>
                                                </li> : ''
                                        }
                                        {
                                            generateTypeUTM ?
                                                <li className="nav-item ms-1" role="presentation">
                                                    <button className={"nav-link utm-color" + (!generateTypeCampaign && !generateTypeAdsSet ? ' active':'')} id="tabUTM-tab" data-bs-toggle="tab"
                                                            data-bs-target="#tabUTM" type="button" role="tab" aria-controls="tabUTM"
                                                            aria-selected="false">UTM
                                                    </button>
                                                </li> : ''
                                        }
                                    </ul>

                                    <div className="tab-content" id="myTabContent">
                                        {
                                            generateTypeCampaign ?
                                                <div className="tab-pane p-2 campaign-bg fade show active" id="tabCampaign" role="tabpanel"
                                                     aria-labelledby="tabCampaign-tab">
                                                    <div className="row g-3 p-2">
                                                        <div className="col-12">
                                                            <div className="d-block mb-1 small">{campaignExample}</div>
                                                        </div>

                                                        <div className="col-12">
                                                            <label htmlFor="agency" className="form-label">Agency <span className="text-danger">*</span></label>
                                                            <Select
                                                                classNamePrefix="form-select-search"
                                                                options={agency}
                                                                onChange={(event) => onChangeAgencyId(event)}
                                                                value={agencyId}
                                                                getOptionValue={(option) => `${option.id}`}
                                                                getOptionLabel={(option) => `${option.slug}`}
                                                            />
                                                        </div>
                                                        {
                                                            campaignAdsNaming === null || campaignAdsNaming.length <= 0 ? (<p>ไม่พบข้อมูล Ads Naming</p>) :
                                                                campaignAdsNaming.map((row, index) => {
                                                                    let inputText = "sourceTypeTextCampaign["+row.id+"]";
                                                                    let formId = '';
                                                                    let source = row.source;
                                                                    let inputType = row.inputType;
                                                                    let selected = null;

                                                                    if(inputType === Utils.ADSNAMING_TYPE_SLUG_PROJECT) {
                                                                        formId = 'slug-project-campaign';
                                                                        return (
                                                                            <div key={index} className="col-12">
                                                                                <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span>
                                                                                    <span className="text-muted small d-block fw-light">{'{lang}-{project-type-slug}-{project-slug}'}</span>
                                                                                </div>
                                                                                <div className=" css-b62m3t-container"><input className="form-control" type="text" id={formId} name={inputText} value={campaignItemSlugProject} disabled={true} /></div>
                                                                            </div>
                                                                        );
                                                                    }
                                                                    else if(inputType === Utils.ADSNAMING_TYPE_SLUG_PROMOTION) {
                                                                        // -- empty
                                                                    }
                                                                    else if(inputType === Utils.ADSNAMING_TYPE_SLUG_SPECIAL) {
                                                                        // -- empty
                                                                    }
                                                                    else if(inputType === Utils.ADSNAMING_TYPE_FREEFORM) {
                                                                        formId = 'freeform';
                                                                        return (
                                                                            <div key={index} className="col-12">
                                                                                <div className="d-block fw-bold">{row.name}</div>
                                                                                <div className=" css-b62m3t-container"><input className="form-control bg-white" type="text" id={formId} name={inputText} defaultValue={campaignItemFreeForm} onKeyUp={async e => {
                                                                                    if(e && e.target.value) {
                                                                                        e.target.value = Utils.utmSlug(e.target.value);
                                                                                    }
                                                                                }} /></div>
                                                                            </div>
                                                                        );
                                                                    }
                                                                    else if(inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {

                                                                        if(campaignItemSelected) {
                                                                            for (let cs of source) {
                                                                                let id = cs.id;
                                                                                let sp = id.split(':KOL');
                                                                                let kol = parseInt(sp[0]) + ':KOL' + parseInt(row.id);
                                                                                if (campaignItemSelected.includes(kol)) {
                                                                                    selected = {id: id, name: cs.name};
                                                                                    break;
                                                                                }
                                                                            }
                                                                        }
                                                                        else {
                                                                            selected = source.filter(e => e.name === 'none')[0];
                                                                        }

                                                                        return (
                                                                            <div key={index} className="col-12">
                                                                                <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span></div>
                                                                                <div className=" css-b62m3t-container">
                                                                                    <Select
                                                                                        name="sourceTypeIdsCampaign[]"
                                                                                        classNamePrefix="form-select-search"
                                                                                        options={source}
                                                                                        defaultValue={selected}
                                                                                        getOptionValue={(option) => `${option.id}`}
                                                                                        getOptionLabel={(option) => `${option.name}`}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    }
                                                                    else {

                                                                        if(campaignItemSelected) {
                                                                            for(let cs of source) {
                                                                                let id = cs.id;
                                                                                if(campaignItemSelected.includes(id)) {
                                                                                    selected = {id: id, name: cs.name};
                                                                                    break;
                                                                                }
                                                                            }
                                                                        }

                                                                        if(row.name !== 'BG' && row.name !== 'AgencyMaster') {
                                                                            return (
                                                                                <div key={index} className="col-12">
                                                                                    <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span></div>
                                                                                    <Select
                                                                                        name="sourceTypeIdsCampaign[]"
                                                                                        classNamePrefix="form-select-search"
                                                                                        options={
                                                                                            platformId ? source.filter(o => o.platform.some(e => e.adsPlatformId === platformId.id)) : source
                                                                                        }
                                                                                        defaultValue={selected}
                                                                                        getOptionValue={(option) => `${option.id}`}
                                                                                        getOptionLabel={(option) => `${option.name}`}
                                                                                    />
                                                                                </div>
                                                                            );
                                                                        }
                                                                        else {

                                                                            if(row.name === 'Agency' || row.name === 'AgencyMaster') {
                                                                                if(roles.agencyId && agency) {
                                                                                    let ag = agency.filter(e => e.id === roles.agencyId)[0];
                                                                                    selected = source.filter(e => e.name === ag.slug);
                                                                                }
                                                                            }

                                                                            return (
                                                                                <div key={index} className="col-12">
                                                                                    <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span></div>
                                                                                    <Select
                                                                                        name="sourceTypeIdsCampaign[]"
                                                                                        classNamePrefix="form-select-search"
                                                                                        options={source}
                                                                                        defaultValue={selected}
                                                                                        getOptionValue={(option) => `${option.id}`}
                                                                                        getOptionLabel={(option) => `${option.name}`}
                                                                                    />
                                                                                </div>
                                                                            );
                                                                        }
                                                                    }
                                                                })
                                                        }

                                                        <div className="col-12 mt-3">
                                                            <label htmlFor="preview" className="form-label"><button type="button" className="btn btn-sm btn-light" onClick={onCampaignPreview} disabled={!agencyId}>Preview</button></label>
                                                            <div className="noselect-url w100 rounded">{campaignPreview}</div>
                                                            <p className="mt-2 mb-0">ตัวอักษร : {campaignPreview.length}</p>
                                                        </div>
                                                    </div>
                                                </div> : ''
                                        }
                                        {
                                            generateTypeAdsSet ?
                                                <div className={"tab-pane p-2 adsset-bg fade" + (!generateTypeCampaign ? ' show active':'')} id="tabAdsSet" role="tabpanel"
                                                     aria-labelledby="tabAdsSet-tab">
                                                    <div className="row g-3 p-2">
                                                        <div className="col-12">
                                                            <div className="d-block mb-1 small">{adssetExample}</div>
                                                        </div>

                                                        {
                                                            adssetAdsNaming === null || adssetAdsNaming.length <= 0 ? (<p>ไม่พบข้อมูล Ads Naming</p>) :
                                                                adssetAdsNaming.map((row, index) => {
                                                                    let inputText = "sourceTypeTextAdsset["+row.id+"]";
                                                                    let formId = '';
                                                                    let source = row.source;
                                                                    let inputType = row.inputType;
                                                                    let selected = null;

                                                                    if(inputType === Utils.ADSNAMING_TYPE_SLUG_PROJECT) {
                                                                        formId = 'slug-project-campaign';
                                                                        return (
                                                                            <div key={index} className="col-12">
                                                                                <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span>
                                                                                    <span className="text-muted small d-block fw-light">{'{lang}-{project-type-slug}-{project-slug}'}</span>
                                                                                </div>
                                                                                <div className=" css-b62m3t-container"><input className="form-control" type="text" id={formId} name={inputText} value={adssetItemSlugProject} disabled={true} /></div>
                                                                            </div>
                                                                        );
                                                                    }
                                                                    else if(inputType === Utils.ADSNAMING_TYPE_SLUG_PROMOTION) {
                                                                        // -- empty
                                                                    }
                                                                    else if(inputType === Utils.ADSNAMING_TYPE_SLUG_SPECIAL) {
                                                                        // -- empty
                                                                    }
                                                                    else if(inputType === Utils.ADSNAMING_TYPE_FREEFORM) {
                                                                        formId = 'freeform';
                                                                        return (
                                                                            <div key={index} className="col-12">
                                                                                <div className="d-block fw-bold">{row.name}</div>
                                                                                <div className=" css-b62m3t-container"><input className="form-control bg-white" type="text" id={formId} name={inputText} defaultValue={adssetItemFreeForm} onKeyUp={async e => {
                                                                                    if(e && e.target.value) {
                                                                                        e.target.value = Utils.utmSlug(e.target.value);
                                                                                    }
                                                                                }} /></div>
                                                                            </div>
                                                                        );
                                                                    }
                                                                    else {

                                                                        if(adssetItemSelected) {
                                                                            for(let cs of source) {
                                                                                let id = cs.id;
                                                                                if(adssetItemSelected.includes(id)) {
                                                                                    selected = {id: id, name: cs.name};
                                                                                    break;
                                                                                }
                                                                            }
                                                                        }

                                                                        if(row.name !== 'BG' && row.name !== 'AgencyMaster') {
                                                                            return (
                                                                                <div key={index} className="col-12">
                                                                                    <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span></div>
                                                                                    <Select
                                                                                        name="sourceTypeIdsAdsset[]"
                                                                                        classNamePrefix="form-select-search"
                                                                                        options={
                                                                                            platformId ? source.filter(o => o.platform.some(e => e.adsPlatformId === platformId.id)) : source
                                                                                        }
                                                                                        defaultValue={selected}
                                                                                        getOptionValue={(option) => `${option.id}`}
                                                                                        getOptionLabel={(option) => `${option.name}`}
                                                                                    />
                                                                                </div>
                                                                            );
                                                                        }
                                                                        else {

                                                                            return (
                                                                                <div key={index} className="col-12">
                                                                                    <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span></div>
                                                                                    <Select
                                                                                        name="sourceTypeIdsAdsset[]"
                                                                                        classNamePrefix="form-select-search"
                                                                                        options={source}
                                                                                        defaultValue={selected}
                                                                                        getOptionValue={(option) => `${option.id}`}
                                                                                        getOptionLabel={(option) => `${option.name}`}
                                                                                    />
                                                                                </div>
                                                                            );
                                                                        }
                                                                    }
                                                                })
                                                        }

                                                        <div className="col-12">
                                                            <label htmlFor="adsNamingSetNameType" className="form-label">Type <span className="text-danger">*</span></label>
                                                            <Select
                                                                classNamePrefix="form-select-search"
                                                                options={adsNamingSetNameType}
                                                                onChange={(event) => onChangeAdsNamingSetNameTypeId(event)}
                                                                value={adsNamingSetNameTypeId}
                                                                getOptionValue={(option) => `${option.id}`}
                                                                getOptionLabel={(option) => `${option.name}`}
                                                            />
                                                        </div>

                                                        <div className="col-12 mt-3">
                                                            <label htmlFor="preview" className="form-label"><button type="button" className="btn btn-sm btn-light" onClick={onAdssetPreview} disabled={!adsNamingSetNameTypeId}>Preview</button></label>
                                                            <div className="noselect-url w100 rounded">{adssetPreview}</div>
                                                            <p className="mt-2 mb-0">ตัวอักษร : {adssetPreview.length}</p>
                                                        </div>
                                                    </div>

                                                </div> : ''
                                        }
                                        {
                                            generateTypeUTM ?
                                                <div className={"tab-pane p-2 utm-bg fade" + (!generateTypeCampaign && !generateTypeAdsSet ? ' show active':'')} id="tabUTM" role="tabpanel"
                                                     aria-labelledby="tabUTM-tab">
                                                    <div className="row g-3 p-2">
                                                        <div className="col-12">
                                                            <label htmlFor="template" className="form-label">Template <span className="text-danger">*</span></label>
                                                            <Select
                                                                isDisabled={!projectId && !campaignId}
                                                                classNamePrefix="form-select-search"
                                                                options={utmTemplate}
                                                                onChange={(event) => onChangeTemplateId(event)}
                                                                value={utmTemplateId}
                                                                getOptionValue={(option) => `${option.id}`}
                                                                getOptionLabel={(option) => `${option.name}`}
                                                            />
                                                        </div>

                                                        <div className={"col-12 " + (utmTemplateId === null ? 'd-none' : '')}>
                                                            {
                                                                utm.length <= 0 ? '' :
                                                                    utm.map((row, index) => {
                                                                        return (
                                                                            showUTMListing ? <div key={index} className={"border rounded bg-yellow-light p-2" + (index+1 !== utm.length ? ' mb-3' : '')}>
                                                                                <div className="d-block fw-bold">{(row.utmPrefix === 1 ? 'utm_':'') + row.name.toLowerCase()} <span className="text-danger">*</span></div>
                                                                                <div className="d-block mb-1 small">{row.example}</div>
                                                                                {
                                                                                    templateSource.length <= 0 ? (<p>ไม่พบข้อมูล source</p>) :
                                                                                        templateSource.map((rs, index2) => {
                                                                                            if(rs.source && rs.utmId === row.id) {

                                                                                                let rsSource = rs.source.sourceType;
                                                                                                let inputType = rs.source.inputType;
                                                                                                let selected = null;
                                                                                                let canBeSelect = false;

                                                                                                if(inputType === Utils.API_TYPE_CONTENT_ID) {
                                                                                                    if(contentId) {
                                                                                                        rsSource = contentId;
                                                                                                        for(let cs of rsSource) {
                                                                                                            cs.id = cs.xid;
                                                                                                            if(utmItemSelected.length && utmItemSelected.includes(cs.xid)) {
                                                                                                                selected = {id: cs.xid, name: cs.name};
                                                                                                            }
                                                                                                        }
                                                                                                        canBeSelect = true;
                                                                                                    }
                                                                                                }
                                                                                                else if(inputType === Utils.API_TYPE_OWNER_ID) {
                                                                                                    if(ownerId) {
                                                                                                        rsSource = ownerId;
                                                                                                        for(let cs of rsSource) {
                                                                                                            cs.id = cs.xid;
                                                                                                            if(utmItemSelected.length && utmItemSelected.includes(cs.xid)) {
                                                                                                                selected = {id: cs.xid, name: cs.name};
                                                                                                            }
                                                                                                        }
                                                                                                        canBeSelect = true;
                                                                                                    }
                                                                                                }
                                                                                                else if(inputType === Utils.API_TYPE_CAMPAIGN_ID) {

                                                                                                    if(campaignId) {
                                                                                                        selected = {
                                                                                                            id: campaignId.campaign_id + ':CP' + rs.source.id,
                                                                                                            name: campaignId.campaign_id
                                                                                                        };
                                                                                                        rsSource = selected;
                                                                                                    }
                                                                                                }
                                                                                                else if(inputType === Utils.API_TYPE_CAMPAIGN_NAME) {

                                                                                                    if(campaignId) {
                                                                                                        selected = {
                                                                                                            id: campaignId.campaign_name + ':CN' + rs.source.id,
                                                                                                            name: campaignId.campaign_name
                                                                                                        };
                                                                                                        rsSource = selected;
                                                                                                    }
                                                                                                }
                                                                                                else if(inputType === Utils.API_TYPE_PROJECT_ID) {

                                                                                                    rsSource = [];
                                                                                                    if(projectId) {
                                                                                                        selected = {
                                                                                                            id: projectId.project_code + ':PJI' + rs.source.id,
                                                                                                            name: projectId.project_code
                                                                                                        };
                                                                                                        rsSource = selected;
                                                                                                    }
                                                                                                }
                                                                                                else if(inputType === Utils.API_TYPE_PROJECT_NAME) {

                                                                                                    if(projectId) {
                                                                                                        let projectName = langId.id + '-' + projectId.project_type_slug + '-' + projectId.project_slug;
                                                                                                        selected = {
                                                                                                            id: projectName + ':PJN' + rs.source.id,
                                                                                                            name: projectName
                                                                                                        };
                                                                                                        rsSource = selected;
                                                                                                    }
                                                                                                }
                                                                                                else if(inputType === Utils.API_TYPE_PROJECT_SLUG) {

                                                                                                    if(projectId) {
                                                                                                        selected = {
                                                                                                            id: projectId.project_slug + ':PJS' + rs.source.id,
                                                                                                            name: projectId.project_slug
                                                                                                        };
                                                                                                        rsSource = selected;
                                                                                                    }
                                                                                                }
                                                                                                else if(inputType === Utils.API_TYPE_PROMOTION_SLUG) {
                                                                                                    //--
                                                                                                }
                                                                                                else if(inputType === Utils.API_TYPE_LINE_OAID) {

                                                                                                    if(projectId) {
                                                                                                        selected = {
                                                                                                            id: projectId.line_oaid + ':LINEOA' + rs.source.id,
                                                                                                            name: projectId.project_title
                                                                                                        };
                                                                                                        rsSource = selected;
                                                                                                    }
                                                                                                }
                                                                                                else {
                                                                                                    for(let s of rsSource) {
                                                                                                        if(utmItemSelected.includes(s.id)) {
                                                                                                            selected = {id: s.id, name: s.name};
                                                                                                        }
                                                                                                    }
                                                                                                    canBeSelect = true;
                                                                                                }

                                                                                                return (
                                                                                                    <div key={index2} className="ms-2 mt-3">
                                                                                                        <div className="row mt-2">
                                                                                                            <div className="col-12 col-sm-4 text-end small">
                                                                                                                {rs.source.name} :
                                                                                                                {userAgency?.isEncrypt === 1 && rs.source.isEncrypt ? <div><span className="badge bg-secondary small">encrypt</span></div>:''}
                                                                                                            </div>
                                                                                                            <div className="col-12 col-sm-8">
                                                                                                                <span className="text-muted small fw-light">{
                                                                                                                    inputType === Utils.API_TYPE_PROJECT_NAME ?
                                                                                                                        '{lang}-{project_type_slug}-{project_slug}' : ''
                                                                                                                }</span>
                                                                                                                <Select
                                                                                                                    isClearable={false}
                                                                                                                    isSearchable={true}
                                                                                                                    name="sourceTypeIds[]"
                                                                                                                    classNamePrefix="form-select-search"
                                                                                                                    placeholder={rsSource.length ? 'Select...':'...'}
                                                                                                                    defaultValue={selected}
                                                                                                                    options={canBeSelect ? rsSource : [rsSource]}
                                                                                                                    getOptionValue={(option) => `${option.id}`}
                                                                                                                    getOptionLabel={(option) => `${option.name}`}
                                                                                                                />
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                );
                                                                                            }
                                                                                        })
                                                                                }
                                                                            </div> : ''
                                                                        );
                                                                    })
                                                            }
                                                        </div>

                                                        <div className="col-12">
                                                            <label htmlFor="typeIed" className="form-label">Hashtag (#)</label>
                                                            <Select
                                                                classNamePrefix="form-select-search"
                                                                options={hashtagList}
                                                                onChange={(event) => onChangeHashtag(event)}
                                                                value={hashtag}
                                                                getOptionValue={(option) => `${option.name}`}
                                                                getOptionLabel={(option) => `${option.name}`}
                                                            />
                                                        </div>

                                                        <div className="col-12">
                                                            <label htmlFor="preview" className="form-label"><button type="button" className="btn btn-sm btn-light" onClick={onUTMPreview} disabled={utmTemplateId == null || utmPreviewing}>Preview</button> <span
                                                                className={utmPreviewing ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span></label>
                                                            <div className="noselect-url w100 rounded">{utmPreview}</div>
                                                        </div>

                                                        <div className={"col-12" + (roles.isShortLink(Utils.MENU_UTM_GENERATE) && rebrandly && rebrandly.status===1 && rebrandly.apiKey && rebrandly.endpoint ? '':' d-none')}>
                                                            <label htmlFor="rebrandlyUrlx" className="form-label">Create Short URL (Rebrandly)</label>
                                                            <div className="form-check form-switch">
                                                                <input className="form-check-input" type="checkbox" name="rebrandlyUrlChecked" id="rebrandlyUrl" defaultChecked={rebrandlyChecked} onChange={e => setRebrandlyChecked(e.target.checked)} />
                                                                <label className="form-check-label" htmlFor="rebrandlyUrl"></label>
                                                            </div>
                                                        </div>

                                                        <div className={"col-12" + (roles.isShortLink(Utils.MENU_UTM_GENERATE) && shortio && shortio.status===1 && shortio.apiKey && shortio.endpoint ? '':' d-none')}>
                                                            <label htmlFor="shortioUrlx" className="form-label">Create Short URL (Short.IO)</label>
                                                            <div className="form-check form-switch">
                                                                <input className="form-check-input" type="checkbox" name="shortioUrlChecked" id="shortioUrl" defaultChecked={shortioChecked} onChange={e => setShortioChecked(e.target.checked)} />
                                                                <label className="form-check-label" htmlFor="shortioUrl"></label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> : ''
                                        }
                                    </div>
                                </> : ''
                        }

                    </div>
                </div>

            </div>
        </main>
    );
} 